import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateAgo',
  pure: false,
  standalone: false,
})
export class DateAgoPipe implements PipeTransform {
  selectedLang: string;

  constructor(private translate: TranslateService) {}

  transform(value: any, args?: any): any {
    this.selectedLang = this.translate.currentLang;
    moment.locale(this.selectedLang);
    return moment(value).fromNow();
  }
}
